import React from 'react';
import './App.css';
import RouteConfig from './router';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';

function App() {
  return (
    <>
      <Header />
      <RouteConfig />
      <Footer />
    </>
  );
}

export default App;
